export type TeamFillRoleSlot = {
  canManage: boolean;
  access: { isHidden: boolean } | null | undefined;
  count: number;
};

export type TeamFillMetric = {
  filled: number;
  total: number;
};

/**
 * Shared n/m fill badge for Team Information cards (create + opened-request).
 * Callers pass resolved counts (state integers or array lengths) so async hydration stays consistent.
 */
export function computeTeamFillMetric(params: {
  roles: TeamFillRoleSlot[];
  isOnline: boolean;
}): TeamFillMetric {
  const slots = params.roles
    .filter((role) => role.canManage && (!role.access || !role.access.isHidden))
    .map((role) => params.isOnline && role.count > 0);
  return { filled: slots.filter(Boolean).length, total: slots.length };
}

/** Populated-role summary segments for optional header subtitle (when re-enabled). */
export function buildTeamSubtitleSummary(params: {
  roles: Array<{ label: string; count: number }>;
  isOnline: boolean;
}): string {
  return params.roles
    .filter((role) => params.isOnline && role.count > 0)
    .map((role) => `${role.label}: ${role.count}`)
    .join(' · ');
}
